import { GOOGLE_CLIENT_ID, LOGIN_REDIRECT_URI } from "../Config";

export const getGoogleLoginUrl = () => {
    const params = new URLSearchParams({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        redirect_uri: `${LOGIN_REDIRECT_URI}/google`,
        response_type: "code",
        scope: [
            "https://www.googleapis.com/auth/userinfo.email",
            "https://www.googleapis.com/auth/userinfo.profile",
        ].join(" "),
        access_type: "offline",
        prompt: "consent",
    });

    return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
};